import { Download, Printer } from "lucide-react";
import { Reveal } from "./Reveal";

const SHEETS = [
  {
    name: "I Hold the Pen!",
    desc: "The reader's pledge in big bubble letters, with pens and stars to color.",
    svg: "/downloads/color-i-hold-the-pen.svg",
    pdf: "/downloads/color-i-hold-the-pen.pdf",
    testid: "printable-pen",
  },
  {
    name: "You Got This!",
    desc: "Man-Man's motto with a football and pom-poms ready for team colors.",
    svg: "/downloads/color-you-got-this.svg",
    pdf: "/downloads/color-you-got-this.pdf",
    testid: "printable-got-this",
  },
  {
    name: "Write Your Own Story",
    desc: "An open book waiting for your words — color it, then write your first line.",
    svg: "/downloads/color-write-your-story.svg",
    pdf: "/downloads/color-write-your-story.pdf",
    testid: "printable-story",
  },
];

export default function Printables() {
  return (
    <section id="printables" data-testid="printables-section" className="relative border-t-2 border-ink bg-crimson/5 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <span className="sticker -rotate-1 rounded-lg bg-white">
            <Printer className="h-3.5 w-3.5" /> Free treat for young readers
          </span>
          <h2 className="mt-5 max-w-2xl font-head text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
            Print. Color. <span className="text-crimson">Make it yours.</span>
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-ink/70 sm:text-lg">
            A taste of <span className="font-bold">Color Your Story!</span> — free printable activity sheets inspired
            by the activity book. Download, print, and grab the crayons.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-3">
          {SHEETS.map((s, i) => (
            <Reveal key={s.name} delay={i * 0.12}>
              <article
                data-testid={s.testid}
                className="group flex h-full flex-col overflow-hidden rounded-2xl border-2 border-ink bg-white shadow-pop transition-all duration-300 hover:-translate-y-1.5 hover:shadow-pop-lg"
              >
                <div className="halftone flex h-72 items-center justify-center overflow-hidden border-b-2 border-ink bg-cream p-5">
                  <img
                    src={s.svg}
                    alt={`${s.name} printable coloring sheet preview`}
                    loading="lazy"
                    className="max-h-full w-auto rounded-md border-2 border-ink bg-white object-contain shadow-pop-sm transition-transform duration-500 group-hover:-rotate-2 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-head text-lg font-extrabold tracking-tight">{s.name}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-ink/70">{s.desc}</p>
                  <a
                    data-testid={`${s.testid}-download-btn`}
                    href={s.pdf}
                    download
                    className="mt-5 flex items-center justify-center gap-2 rounded-full border-2 border-ink bg-white px-5 py-2.5 font-head text-sm font-extrabold uppercase tracking-wide shadow-pop-sm transition-all duration-200 hover:-translate-y-0.5 hover:bg-banana hover:shadow-pop"
                  >
                    <Download className="h-4 w-4" /> Download PDF
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
